import type { GroupedOption, SingleValue } from '@ksyos/design-system';
import { Select } from '@ksyos/design-system';
import type { IReactSelectOptions } from '@frontend/components/interfaces';
import { translateKey } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils';

interface IPatientTaskItemPerformerSelectProps {
    error?: string;
    id?: string;
    onChange: (option: SingleValue<IReactSelectOptions>) => Promise<void>;
    options: GroupedOption[];
    value?: GroupedOption;
}

export function PatientTaskItemPerformerSelect(props: IPatientTaskItemPerformerSelectProps) {
    return (
        <Select
            error={getValidationErrorTranslation(props.error)}
            filterOption={filterOptions}
            id={props.id}
            key={'select-form-performer-option'}
            noOptionsMessage={() => translateKey('common.typeToSearch')}
            onChange={props.onChange}
            options={props.options}
            placeholder="Kies een uitvoerder..."
            value={props.value ?? null}
        />
    );

    function filterOptions(filterOption: IReactSelectOptions, input: string) {
        return filterOption.label.toLowerCase().includes(input.toLowerCase());
    }
}
